export default __webpack_public_path__ + "static/media/bootstrap.e70fd84e.svg";